export default {
    GET_FACILITY_ALLOCATIONS (state, data) {
      state.facility_allocations = data.data
    },
   
    GET_DELETED_FACILITY_ALLOCATIONS (state, data) {
      state.deleted_facility_allocations = data.data
    }
  }
  